// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.btn {
    padding-left: 3rem;
    padding-right: 3rem;
}

.btn-outline-primary {
    border: 1px solid #dbc700;
    color: black;
    background: transparent;
}

.btn-outline-primary:hover,
.btn-outline-primary:active {
    background: #dbc700;
    color: white;
}

.header-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

label {
    font-weight: bold;
}

.require-label:after {
    content: ' *';
    color: red;
}

.close {
}

.content-header {
    font-style: normal;
    font-weight: 600;
    font-size: 1.2rem;
    line-height: 27px;
    padding: 19px 0px 14px 0px;
}

/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImNyZWF0ZS1pdGVtLWRpYWxvZy5jb21wb25lbnQuY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0lBQ0ksa0JBQWtCO0lBQ2xCLG1CQUFtQjtBQUN2Qjs7QUFFQTtJQUNJLHlCQUF5QjtJQUN6QixZQUFZO0lBQ1osdUJBQXVCO0FBQzNCOztBQUVBOztJQUVJLG1CQUFtQjtJQUNuQixZQUFZO0FBQ2hCOztBQUVBO0lBQ0ksYUFBYTtJQUNiLG1CQUFtQjtJQUNuQiw4QkFBOEI7QUFDbEM7O0FBRUE7SUFDSSxpQkFBaUI7QUFDckI7O0FBRUE7SUFDSSxhQUFhO0lBQ2IsVUFBVTtBQUNkOztBQUVBO0FBQ0E7O0FBRUE7SUFDSSxrQkFBa0I7SUFDbEIsZ0JBQWdCO0lBQ2hCLGlCQUFpQjtJQUNqQixpQkFBaUI7SUFDakIsMEJBQTBCO0FBQzlCIiwiZmlsZSI6ImNyZWF0ZS1pdGVtLWRpYWxvZy5jb21wb25lbnQuY3NzIiwic291cmNlc0NvbnRlbnQiOlsiLmJ0biB7XG4gICAgcGFkZGluZy1sZWZ0OiAzcmVtO1xuICAgIHBhZGRpbmctcmlnaHQ6IDNyZW07XG59XG5cbi5idG4tb3V0bGluZS1wcmltYXJ5IHtcbiAgICBib3JkZXI6IDFweCBzb2xpZCAjZGJjNzAwO1xuICAgIGNvbG9yOiBibGFjaztcbiAgICBiYWNrZ3JvdW5kOiB0cmFuc3BhcmVudDtcbn1cblxuLmJ0bi1vdXRsaW5lLXByaW1hcnk6aG92ZXIsXG4uYnRuLW91dGxpbmUtcHJpbWFyeTphY3RpdmUge1xuICAgIGJhY2tncm91bmQ6ICNkYmM3MDA7XG4gICAgY29sb3I6IHdoaXRlO1xufVxuXG4uaGVhZGVyLWNvbnRlbnQge1xuICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgICBqdXN0aWZ5LWNvbnRlbnQ6IHNwYWNlLWJldHdlZW47XG59XG5cbmxhYmVsIHtcbiAgICBmb250LXdlaWdodDogYm9sZDtcbn1cblxuLnJlcXVpcmUtbGFiZWw6YWZ0ZXIge1xuICAgIGNvbnRlbnQ6ICcgKic7XG4gICAgY29sb3I6IHJlZDtcbn1cblxuLmNsb3NlIHtcbn1cblxuLmNvbnRlbnQtaGVhZGVyIHtcbiAgICBmb250LXN0eWxlOiBub3JtYWw7XG4gICAgZm9udC13ZWlnaHQ6IDYwMDtcbiAgICBmb250LXNpemU6IDEuMnJlbTtcbiAgICBsaW5lLWhlaWdodDogMjdweDtcbiAgICBwYWRkaW5nOiAxOXB4IDBweCAxNHB4IDBweDtcbn1cbiJdfQ== */`, "",{"version":3,"sources":["webpack://./src/app/all-modules/team/components/create-item-dialog/create-item-dialog.component.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,uBAAuB;AAC3B;;AAEA;;IAEI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,UAAU;AACd;;AAEA;AACA;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,0BAA0B;AAC9B;;AAEA,wgDAAwgD","sourcesContent":[".btn {\n    padding-left: 3rem;\n    padding-right: 3rem;\n}\n\n.btn-outline-primary {\n    border: 1px solid #dbc700;\n    color: black;\n    background: transparent;\n}\n\n.btn-outline-primary:hover,\n.btn-outline-primary:active {\n    background: #dbc700;\n    color: white;\n}\n\n.header-content {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\nlabel {\n    font-weight: bold;\n}\n\n.require-label:after {\n    content: ' *';\n    color: red;\n}\n\n.close {\n}\n\n.content-header {\n    font-style: normal;\n    font-weight: 600;\n    font-size: 1.2rem;\n    line-height: 27px;\n    padding: 19px 0px 14px 0px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
